import { cn } from '@/lib/utils';
export default function SectionTitle({ title, subtitle, description, className, outlined = false, }) {
    return (<div className={cn('mb-12 md:mb-16', className)}>
      {subtitle && <p className='text-lg font-noto mb-2'>{subtitle}</p>}
      <h2 className={cn('text-5xl md:text-6xl font-bebas tracking-wider', outlined &&
            'text-transparent bg-clip-text bg-gradient-to-r from-navy to-navy')}>
        {title}
      </h2>
      {description && (<p className='text-lg text-gray-600 mt-4'>{description}</p>)}
    </div>);
}
